function initCountUp(element) {
    if (element.getAttribute('data-countup-initialized')) return;
    element.setAttribute('data-countup-initialized', 'true');

    // 使用 ID 查找数字元素
    const numberSpan = element.querySelector('#js-count-number');
    
    if (!numberSpan) return;

    const target = parseInt(numberSpan.getAttribute('data-target'), 10);
    const duration = 2000; 
    let startTimestamp = null;
    
    // 初始设置：只显示 0
    numberSpan.textContent = '0';

    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        
        const currentCount = Math.floor(progress * target);
        
        // 关键：只更新数字
        numberSpan.textContent = currentCount; 
        
        if (progress < 1) {
            window.requestAnimationFrame(step);
        } else {
            // 动画结束，显示最终值
            numberSpan.textContent = target; 
        }
    };
    
    window.requestAnimationFrame(step);

    // 动画开始后，设置整个包装器可见
    element.style.opacity = 1;
    element.style.transform = 'translateY(0)';
}

function observeCountUpElements() {
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initCountUp(entry.target);
                observer.unobserve(entry.target);
            }
        });
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });
        document.querySelectorAll('.js-impact-text-wrapper').forEach(element => {
            observer.observe(element);
        });
    } else {
        document.querySelectorAll('.js-impact-text-wrapper').forEach(element => {
            initCountUp(element);
        });
    }
}

document.addEventListener('DOMContentLoaded', observeCountUpElements);